module.exports = __webpack_public_path__ + "media/packs/src/assets/images/mb-main-slide-img-2-d2f1aef850243b4ead5752a78f61c6d2.png";